import React from "react";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";

import { BrowserAgent } from "@newrelic/browser-agent/loaders/browser-agent";
import { reportWebVitals } from "./Utils/webVitals";

// By default, the local app is used
let options;

switch (import.meta.env.VITE_ENV) {
  case "dev":
    options = {
      init: {
        session_replay: {
          enabled: true,
          block_selector: "",
          mask_text_selector: "*",
          sampling_rate: 10.0,
          error_sampling_rate: 100.0,
          mask_all_inputs: true,
          collect_fonts: true,
          inline_images: false,
          inline_stylesheet: true,
          mask_input_options: {},
        },
        distributed_tracing: { enabled: true },
        privacy: { cookies_enabled: true },
        ajax: { deny_list: ["bam.eu01.nr-data.net"] },
        distributed_tracing: { enabled: true },
        privacy: { cookies_enabled: true },
        ajax: { deny_list: ["bam.eu01.nr-data.net"] },
      }, // NREUM.init
      info: {
        beacon: "bam.eu01.nr-data.net",
        errorBeacon: "bam.eu01.nr-data.net",
        licenseKey: "NRJS-25aba08515f792f0361",
        applicationID: "538676216",
        sa: 1,
      }, // NREUM.info
      loader_config: {
        accountID: "6310012",
        trustKey: "6310012",
        agentID: "538676216",
        licenseKey: "NRJS-25aba08515f792f0361",
        applicationID: "538676216",
      }, // NREUM.loader_config
    };
    break;
  case "staging":
    options = {
      init: {
        session_replay: {
          enabled: true,
          block_selector: "",
          mask_text_selector: "*",
          sampling_rate: 10.0,
          error_sampling_rate: 100.0,
          mask_all_inputs: true,
          collect_fonts: true,
          inline_images: false,
          inline_stylesheet: true,
          mask_input_options: {},
        },
        distributed_tracing: { enabled: true },
        privacy: { cookies_enabled: true },
        ajax: { deny_list: ["bam.eu01.nr-data.net"] },
      }, // NREUM.init
      info: {
        beacon: "bam.eu01.nr-data.net",
        errorBeacon: "bam.eu01.nr-data.net",
        licenseKey: "NRJS-25aba08515f792f0361",
        applicationID: "538676219",
        sa: 1,
      }, // NREUM.info
      loader_config: {
        accountID: "6310012",
        trustKey: "6310012",
        agentID: "538676219",
        licenseKey: "NRJS-25aba08515f792f0361",
        applicationID: "538676219",
      }, // NREUM.loader_config
    };
    break;
  case "production":
    options = {
      init: {
        session_replay: {
          enabled: true,
          block_selector: "",
          mask_text_selector: "*",
          sampling_rate: 10.0,
          error_sampling_rate: 100.0,
          mask_all_inputs: true,
          collect_fonts: true,
          inline_images: false,
          inline_stylesheet: true,
          mask_input_options: {},
        },
        distributed_tracing: { enabled: true },
        privacy: { cookies_enabled: true },
        ajax: { deny_list: ["bam.eu01.nr-data.net"] },
      }, // NREUM.init
      info: {
        beacon: "bam.eu01.nr-data.net",
        errorBeacon: "bam.eu01.nr-data.net",
        licenseKey: "NRJS-25aba08515f792f0361",
        applicationID: "538676220",
        sa: 1,
      }, // NREUM.info
      loader_config: {
        accountID: "6310012",
        trustKey: "6310012",
        agentID: "538676220",
        licenseKey: "NRJS-25aba08515f792f0361",
        applicationID: "538676220",
      }, // NREUM.loader_config
    };
    break;
  default:
    options = {
      init: {
        session_replay: {
          enabled: true,
          block_selector: "",
          mask_text_selector: "*",
          sampling_rate: 10.0,
          error_sampling_rate: 100.0,
          mask_all_inputs: true,
          collect_fonts: true,
          inline_images: false,
          inline_stylesheet: true,
          mask_input_options: {},
        },
        distributed_tracing: { enabled: true },
        privacy: { cookies_enabled: true },
        ajax: { deny_list: ["bam.eu01.nr-data.net"] },
      }, // NREUM.init
      info: {
        beacon: "bam.eu01.nr-data.net",
        errorBeacon: "bam.eu01.nr-data.net",
        licenseKey: "NRJS-25aba08515f792f0361",
        applicationID: "538668978",
        sa: 1,
      }, // NREUM.info
      loader_config: {
        accountID: "6310012",
        trustKey: "6310012",
        agentID: "538668978",
        licenseKey: "NRJS-25aba08515f792f0361",
        applicationID: "538668978",
      }, // NREUM.loader_config
    };
}

// The agent loader code executes immediately on instantiation.
new BrowserAgent(options);

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </HelmetProvider>
);

reportWebVitals();
